import { gross, isPro, lei, packTotals, shortName } from "@/lib/pricing";
import ProfitCalculator from "./ProfitCalculator";

const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

const PackProfit = ({ pack, data }) => {
  const t = packTotals(pack, data);
  const revenue = t.revenue;
  return (
    <article className="pf-card" data-testid={`profit-pack-${pack.id}`}>
      <div className="pf-card-head">
        <b>{pack.name}</b>
        <span className="pf-badge">-{pack.discount}%</span>
      </div>
      <div className="pf-bar">
        <span style={{ width: `${pct(t.price, revenue)}%` }} />
      </div>
      <dl className="pf-grid">
        <div><dt>Investești</dt><dd>{lei(t.price)}</dd></div>
        <div><dt>{t.treatments} tratamente</dt><dd>{lei(t.treatRevenue)}</dd></div>
        <div className="is-resale"><dt>Revânzare</dt><dd>{lei(t.resale)}</dd></div>
        <div><dt>Total încasări</dt><dd>{lei(revenue)}</dd></div>
        <div className="is-main"><dt>Profit</dt><dd>{lei(t.profit)}</dd></div>
        <div className="is-main"><dt>Randament</dt><dd>{pct(t.profit, t.price)}%</dd></div>
      </dl>
      {t.gifts > 0 && <p className="pf-note">Include cadouri în valoare de {lei(t.gifts)} (preț listă), revândute cu +{data.markup}%.</p>}
    </article>
  );
};

export default function Profit({ data, track }) {
  const m = data.markup;
  const setCost = data.products.filter((p) => isPro(data, p.id)).reduce((s, p) => s + gross(p.price, data.vat), 0);
  return (
    <section className="pub-section" data-testid="section-profit">
      <header className="pub-sec-head">
        <span className="pub-eyebrow">Cât câștigă salonul</span>
        <h2>Profitabilitate</h2>
        <p>Formatele mari se folosesc în salon: un set (Pre-Shampoo 400 ml, Shampoo 500 ml, Conditioner 400 ml) = minim {data.treatments} tratamente × minim {data.service_price} lei. Toate celelalte produse, inclusiv cadourile, se revând la prețul de listă +{data.markup}%. Toate sumele includ TVA.</p>
      </header>
      <ProfitCalculator data={data} track={track} />
      <h3 className="pub-sub">Pe pachete</h3>
      <div className="pf-cards">
        {data.packages.map((pk) => <PackProfit key={pk.id} pack={pk} data={data} />)}
      </div>
      <h3 className="pub-sub">Pe produs, la preț de listă</h3>
      <p className="pf-note pf-note--set">Un set complet de formate mari, la preț de listă ({lei(setCost)}), aduce {data.treatments} × {data.service_price} = <b>{lei(data.treatments * data.service_price)}</b>, adică profit <b>{lei(data.treatments * data.service_price - setCost)}</b>.</p>
      <ul className="pl-list pl-list--compact">
        {data.products.map((p) => (
          <li key={p.id} className="pl-row" data-testid={`profit-row-${p.id}`}>
            <div className="pl-info">
              <b>{shortName(p.name)} <span className="pl-size">{p.size}</span></b>
              <span className="pl-idx">{isPro(data, p.id) ? `Cost ${lei(gross(p.price, data.vat))} · format profesional` : <>Cost {lei(gross(p.price, data.vat))} · <span className="pl-resale">vânzare {lei(gross(p.price, data.vat) * (1 + m / 100))}</span></>}</span>
            </div>
            {isPro(data, p.id) ? (
              <div className="pl-price pl-price--resale pl-price--pro"><b>Uz salon</b><span>parte din set</span></div>
            ) : (
              <div className="pl-price pl-price--resale">
                <b>+{lei(gross(p.price, data.vat) * (m / 100))}</b>
                <span>/ bucată</span>
              </div>
            )}
          </li>
        ))}
      </ul>
      <p className="pf-note">Pachetele aduc randament mai mare, datorită discountului financiar.</p>
    </section>
  );
}
